import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';
import Perfil from '../pages/Perfil';
import Logista from '../pages/Logista';
import Checkout from '../pages/Checkout';
import EnviosViagens from '../pages/EnviosViagens';
import MerchantDashboard from '../pages/MerchantDashboard';
import CourierDashboard from '../pages/CourierDashboard';
import RestaurantMenu from '../pages/RestaurantMenu';
import RestaurantInfo from '../pages/RestaurantInfo';
import RestaurantsCategories from '../pages/RestaurantsCategories';
import RestaurantsByCategory from '../pages/RestaurantsByCategory';
import Promotions from '../pages/Promotions';
import Help from '../pages/Help';
import About from '../pages/About';
import Legal from '../pages/Legal';
import PrivateRoute from './PrivateRoute';
import Forbidden from '../pages/Forbidden';
import AdminSettings from '../admin/pages/Settings';
import AdminAudit from '../admin/pages/Audit';
import AdminContent from '../admin/pages/ContentAppearance';
import AdminAppearance from '../admin/pages/AdminAppearance';
import AdminFees from '../admin/pages/Fees';
import AdminRadius from '../admin/pages/Radius';
import AdminFinance from '../admin/pages/Finance';
import AdminValidations from '../admin/pages/Validations';
import AdminOrders from '../admin/pages/Orders';
import AdminCustomers from '../admin/pages/Customers';
import AdminCouriers from '../admin/pages/Couriers';
import CourierVerification from '../admin/pages/CourierVerification';
import AdminStoreDetails from '../admin/pages/StoreDetails';
import AdminStores from '../admin/pages/Stores';
import AdminDashboard from '../admin/pages/Dashboard';
import AdminLayout from '../admin/components/AdminLayout';
import RequireAdmin from './RequireAdmin';
import { useAuth } from '../contexts/AuthContext';

function HomeRouteEntry() {
  const { user, loading } = useAuth();

  if (loading) return <p>Carregando...</p>;
  if (user?.role === 'admin') return <Navigate to="/admin/dashboard" replace />;
  if (user?.role === 'merchant') return <Navigate to="/logista" replace />;
  if (user?.role === 'courier') return <Navigate to="/entregas" replace />;

  return <Home />;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Rotas publicas */}
      <Route path="/" element={<HomeRouteEntry />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/store/:id" element={<RestaurantMenu />} />
      <Route path="/store/:id/info" element={<RestaurantInfo />} />
      <Route path="/restaurantes" element={<RestaurantsCategories />} />
      <Route path="/restaurantes/categoria/:categoryName" element={<RestaurantsByCategory />} />
      <Route path="/promocoes" element={<Promotions />} />
      <Route path="/ajuda" element={<Help />} />
      <Route path="/sobre-nos" element={<About />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/403" element={<Forbidden />} />

      {/* Rotas protegidas - Usuario */}
      <Route
        path="/perfil"
        element={
          <PrivateRoute allowedRoles={['user']} redirectTo="/">
            <Perfil />
          </PrivateRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute allowedRoles={['user']} redirectTo="/">
            <Navigate to="/perfil?tab=orders" replace />
          </PrivateRoute>
        }
      />

      <Route
        path="/user/dashboard"
        element={
          <PrivateRoute allowedRoles={['user']} redirectTo="/">
            <Navigate to="/perfil?tab=orders" replace />
          </PrivateRoute>
        }
      />

      {/* Rotas protegidas - Merchant */}
      <Route
        path="/logista"
        element={
          <PrivateRoute allowedRoles={['merchant']} redirectTo="/">
            <Logista />
          </PrivateRoute>
        }
      />

      <Route
        path="/merchant/dashboard"
        element={
          <PrivateRoute allowedRoles={['merchant']} redirectTo="/">
            <MerchantDashboard />
          </PrivateRoute>
        }
      />

      {/* Rota protegida - Courier */}
      <Route
        path="/entregas"
        element={
          <PrivateRoute allowedRoles={['courier']} redirectTo="/">
            <CourierDashboard />
          </PrivateRoute>
        }
      />

      {/* Checkout */}
      <Route
        path="/checkout"
        element={
          <PrivateRoute allowedRoles={['user']} redirectTo="/">
            <Checkout />
          </PrivateRoute>
        }
      />

      <Route
        path="/perfil/envios-viagens"
        element={
          <PrivateRoute allowedRoles={['user']} redirectTo="/">
            <EnviosViagens />
          </PrivateRoute>
        }
      />
    
      {/* Admin Area */}
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="lojas" element={<AdminStores />} />
        <Route path="lojas/:id" element={<AdminStoreDetails />} />
        <Route path="motoboys" element={<AdminCouriers />} />
        <Route path="motoboys/verificacoes" element={<CourierVerification />} />
        <Route path="clientes" element={<AdminCustomers />} />
        <Route path="pedidos" element={<AdminOrders />} />
        <Route path="avaliacoes-validacoes" element={<AdminValidations />} />
        <Route path="financeiro" element={<AdminFinance />} />
        <Route path="taxas-regras" element={<AdminFees />} />
        <Route path="raio" element={<AdminRadius />} />
        <Route path="conteudo-aparencia" element={<AdminContent />} />
        <Route path="aparencia-admin" element={<AdminAppearance />} />
        <Route path="auditoria" element={<AdminAudit />} />
        <Route path="configuracoes" element={<AdminSettings />} />
      </Route>
    
    </Routes>
  );
}
